import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import { officesSelector } from '@selectors/filterServicesSelector';
import getOfficeSlug from '@helpers/getOfficeSlug';
import getOfficeByOkato from '@helpers/getOfficeByOkato';

type OptionLabelProps = {
  option: {
    name: string;
    id: number | string;
  };
  renderAdditional: (option) => null;
  filterType: string;
  offices: [any];
};

const OptionLabel: FC<OptionLabelProps> = ({
  option,
  renderAdditional,
  filterType,
  offices,
}) => {
  if (filterType === 'areas') {
    const office = getOfficeByOkato(option.id, offices);

    if (office) {
      const props = {
        to: `/${getOfficeSlug(office)}/`,
        onClick: (ev) => {
          if (ev.target.tagName === 'A') {
            ev.preventDefault();

            const label = ev.target.closest('label');

            if (label) {
              label.dispatchEvent(new MouseEvent('click', { bubbles: true }));
            }
          }
        },
      };

      return (
        <Link className="labelWraper" to={props.to} onClick={props.onClick}>
          {option.name}
          {renderAdditional(option)}
        </Link>
      );
    }
  }

  return (
    <span className="labelWraper">
      {option.name}
      {renderAdditional(option)}
    </span>
  );
};

export default connect((state) => ({
  offices: officesSelector(state),
}))(OptionLabel);
